import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { PublicHeader, Wordmark } from "../components/PublicHeader";
import { GoogleButton } from "../components/GoogleButton";
import { api, formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function SignIn() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const { setUser } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      toast.success("Welcome back");
      navigate(data.role === "employer" ? "/employer" : "/candidate");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#f5f3ee]">
      <PublicHeader />
      <div className="pt-16 min-h-screen flex items-center justify-center px-6 py-16">
        <div className="w-full max-w-md bg-white rounded-lg border border-[#e3e0d3] p-8 sm:p-10">
          <Wordmark />
          <h1 className="text-2xl font-bold text-[#0d2f4d] tracking-tight mt-6">Sign in</h1>
          <p className="text-sm text-[#51637a] mt-1">We'll route you to the right dashboard.</p>
          <form onSubmit={submit} className="mt-8 space-y-5">
            <div>
              <label className="text-xs uppercase tracking-[0.15em] font-medium text-[#51637a]">Email</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                data-testid="signin-email-input"
                className="mt-1.5 w-full rounded-lg border border-[#e3e0d3] px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#94a01a]" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.15em] font-medium text-[#51637a]">Password</label>
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                data-testid="signin-password-input"
                className="mt-1.5 w-full rounded-lg border border-[#e3e0d3] px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#94a01a]" />
              <Link to="/forgot-password" data-testid="forgot-password-link"
                className="inline-block mt-2 text-xs text-[#7C8514] font-medium hover:underline">
                Forgot password?
              </Link>
            </div>
            <button type="submit" disabled={busy} data-testid="signin-submit-button"
              className="w-full rounded-full bg-[#0d2f4d] text-white font-medium py-3.5 hover:bg-[#1c4d78] transition-colors disabled:opacity-60">
              {busy ? "Signing in..." : "Sign in"}
            </button>
          </form>
          <div className="my-6 flex items-center gap-3">
            <div className="h-px flex-1 bg-[#e3e0d3]" />
            <span className="text-xs text-[#51637a] uppercase tracking-[0.15em]">or</span>
            <div className="h-px flex-1 bg-[#e3e0d3]" />
          </div>
          <GoogleButton />
          <div className="mt-8 border-t border-[#e3e0d3] pt-6 text-sm text-[#51637a] space-y-2">
            <p>New candidate? <Link to="/signup/candidate" data-testid="signin-link-candidate-signup" className="text-[#7C8514] font-medium hover:underline">Join the talent pool</Link></p>
            <p>Hiring? <Link to="/signup/employer" data-testid="signin-link-employer-signup" className="text-[#7C8514] font-medium hover:underline">Create an employer account</Link></p>
          </div>
        </div>
      </div>
    </div>
  );
}
